import Moment from 'moment';
import { VatTariffs } from '../VatService';
import Resource from './Resource';

/**
 * Payment Resource
 */
class Payment extends Resource
{
    constructor() {
        super('accounting.payment', ['payments']);
    }

    options() {
        return this._doGet(['options']);
    }
}   

export let PaymentResource = new Payment();

export let PaymentSchema = function(defaults = {}) {
    let schema = {
        invoice_id: null,
        provider_id: null,
        reference: null,
        type: PaymentTypes.OTHER,
        method: null,
        amount: 0,
        commission_amount: null,
        commission_paid_at: null,
        commission_payment_method: null,
        payment_term: null,
        finance_type: null,
        finance_monthly_payment: null,
        finance_balloon_payment: null,
        is_signed: false,
        is_posted: false,
        is_approved: false,
        is_banked: false,
        is_refunded: false,
        is_voided: false,
        paid_at: null,
    };

    if (defaults) {
        schema = Object.assign(schema, defaults);
    }

   return schema;
}

export let PaymentMethods = {
    CARD: 'card', 
    CASH: 'cash',
    CHEQUE: 'cheque', 
    BANK_TRANSFER: 'bank_transfer', 
    FINANCE: 'finance',
    TBC: 'tbc',
    EXISTING_CREDIT: 'credit_note',
};

export let PaymentMethodKeyValueList = [
    { value: PaymentMethods.CARD, label: 'Card' },
    { value: PaymentMethods.CASH, label: 'Cash' },
    { value: PaymentMethods.CHEQUE, label: 'Cheque' },
    { value: PaymentMethods.BANK_TRANSFER, label: 'Bank Transfer' },
    { value: PaymentMethods.FINANCE, label: 'Finance' },
    { value: PaymentMethods.TBC, label: 'TBC' },
    { value: PaymentMethods.EXISTING_CREDIT, label: 'Part Exchange Credit' }
];

export let PaymentTypes = {
    DEPOSIT: 'deposit', 
    BALANCE: 'balance',
    PART_EXCHANGE: 'part_exchange',
    REFUND: 'refund',
    OTHER: 'other',
};

export let FinanceTypes = {
    PCP: 'pcp',
    HP: 'hp',
    CS: 'cs',
};

export let FinanceTypeKeyValueList = [
    { value: FinanceTypes.PCP, label: 'PCP' },
    { value: FinanceTypes.HP, label: 'HP' },
    { value: FinanceTypes.CS, label: 'CS' },
]

export let getPaymentMethodText = (method) => {
    for (let i in PaymentMethodKeyValueList) {
        if (method === PaymentMethodKeyValueList[i].value) {
            return PaymentMethodKeyValueList[i].label;
        }
    }

    return 'Unknown';
}